// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".path-2 {\r\n  fill:none\r\n}\r\n.path-3 {\r\n  fill:#fff\r\n}\r\n.path-4 {\r\n  fill:#f7f8f7\r\n}\r\n.path-5 {\r\n  fill:#e9e9ea\r\n}\r\n.cls-1 {\r\n  fill:none;\r\n  clip-rule:evenodd\r\n}\r\n.cls-7 {\r\n  clip-path:url(#clip-path-2)\r\n}\r\n.g-2 {\r\n  clip-path:url(#clip-path)\r\n}\r\n.g-3 {\r\n  clip-path:url(#clip-path-3)\r\n}\r\n", ""]);
// Exports
module.exports = exports;
